<template>
  <div class="contact-us" @click="activityAddress = null">
    <div class="page-content">
      <div class="content-wrap">
        <div class="content-title-card">
          <div class="content-zh">联系华跃</div>
          <div class="phone-wrap">服务热线 <span v-html="Hotline"></span></div>
        </div>
        <div class="address-wrap">
          <div class="address-map">
            <div
              v-for="(locationItem, index) in addressList"
              :key="index"
              class="location-item"
              :style="{transform: `translate(${locationItem.position[0]}px, ${locationItem.position[1]}px)`}"
              @click.stop="activity(index)"
              ref="locationItem"
            >
              <!-- @mouseenter="setCanvas(index)"
              @mouseleave="closeCanvas" -->
              <img
                src="@/assets/contact/location.png"
                alt=""
                :class="['location-img', cavasIndex == index ? 'animationImg' : '']"
              />
              <canvas :id="'canvas'+index" class="location-canvas" width="30" height="30"></canvas>
            </div>
          </div>
          <div class="address-list">
            <div
              v-for="(item, index) in addressList"
              :key="index"
              :class="['address-item', activityAddress == index ? 'activity' : '']"
            >
              <img :src="item.img" alt="" class="address-img" />
              <div class="address-title">{{ item.title }}</div>
              <div class="address-description">{{ item.summaryTitle }}</div>
              <div class="address-phone">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getColumnChild } from "@/api/column";
import { getContentDetail, getContentList } from "@/api/content";
import { getVariableInfo } from '@/api/variable';
export default {
  name: "ContactUsView",
  data() {
    return {
      ctx: null,
      radius: 0,
      pageContent: "",
      activityAddress: null,
      addressList: [],
      cavasIndex: null,
      Hotline: '',
    };
  },
  mounted() {
    this.getPageDetails();
    this.getVariable();
  },
  methods: {
    async getPageDetails() {
      var params = { parentId: "1624978949178351616" };
      var res = await getColumnChild(params);
      var { result } = res;
      for (var i = 0; i < result.length; i++) {
        if (i === 0) {
          const data = { columnId: result[i].id, pageNum: 1, pageSize: 99 };
          getContentList(data).then(async (rrs) => {
            const rrsult = rrs.result;
            for (var j = 0; j < rrsult.data.length; j++) {
              var addressItem = {
                img: rrsult.data[j].icon,
                title: rrsult.data[j].title,
                summaryTitle: rrsult.data[j].summaryTitle,
                description: rrsult.data[j].description,
                position: [],
                radius: 0,
                ctx: null,
                canvarInterval: null,
              };
              const rts = await getContentDetail(rrsult.data[j].id);
              const rtsult = rts.result;
              for (var x = 0; x < rtsult.elements.length; x++) {
                addressItem.position.push(Number(rtsult.elements[x].content));
              }
              this.addressList.push(addressItem);
            }
            this.$nextTick(()=>{
              for (var j = 0; j < this.addressList.length; j++) {
                this.setCanvas(j)
              }
            });
          });
        }
      }
    },
    getVariable() {
      getVariableInfo({ label: 'Hotline', }).then((res) => {
        const { result, } = res;
        var doc = new DOMParser().parseFromString(result.content, 'text/html');
        this.Hotline = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
      });
    },
    activity(index) {
      this.activityAddress = index
    },
    setCanvas(index) {
      this.cavasIndex = index;
      this.$nextTick(() => {
        const c  = document.getElementById(`canvas${index}`)
        this.addressList[index].ctx = c.getContext('2d');
        this.drawCircle(index);
        this.addressList[index].canvarInterval = setInterval(() => {
          this.drawCircle(index);
        },50)
      
      })
    },
    closeCanvas() {
      this.cavasIndex = null
      this.radius = 0
      this.ctx.clearRect(0, 0, 30, 30);
      clearInterval(this.canvarInterval)
    },
    drawCircle(index) {
      this.addressList[index].ctx.beginPath();
      let prev = this.addressList[index].ctx.globalCompositeOperation;
      this.addressList[index].ctx.globalCompositeOperation = 'destination-in';
      this.addressList[index].ctx.globalAlpha = 0.95;
      this.addressList[index].ctx.fillRect(0,0,30,30);
      this.addressList[index].ctx.globalCompositeOperation = prev;
      this.addressList[index].ctx.arc(15, 15, this.addressList[index].radius, 0, Math.PI * 2);
      this.addressList[index].ctx.closePath();
      this.addressList[index].ctx.lineWidth = 2;
      this.addressList[index].ctx.strokeStyle = 'rgba(250,98,40,1)';
      this.addressList[index].ctx.stroke();
      this.addressList[index].radius += 0.5;
      if (this.addressList[index].radius > 10) {
        this.addressList[index].radius = 0
      }
    }
  },
};
</script>

<style lang="less">
.phone-wrap{
  p{
    display: inline-block;
  }
}
</style>

<style lang="less" scoped>
.contact-us {
  background-color: #fff;
  margin-bottom: 80px;
  .page-content {
    width: 100%;
    .content-wrap {
      width: 1200px;
      margin: 0 auto;
      .content-title-card {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .content-zh {
          font-family: Alibaba-PuHuiTi-R;
          font-size: 34px;
          color: #3f3f3f;
          margin-right: 6px;
        }
        .phone-wrap {
          font-family: Alibaba-PuHuiTi-R;
          font-size: 18px;
          color: #31b3dc;
        }
      }
      .address-wrap {
        width: 100%;
        padding: 0 14px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
        .address-map {
          width: 516px;
          height: 405px;
          background: url("@/assets/contact/map.png") no-repeat;
          background-size: cover;
          position: relative;
          .location-item {
            position: absolute;
            top: 0;
            left: 0;
            width: 23px;
            transform-origin: center bottom;
            cursor: pointer;
            .location-img {
              width: 100%;
              position: relative;
              height: auto;
              display: block;
              filter: drop-shadow(4px 3px 9px rgba(1, 14, 66, 0.43));
              z-index: 2;
              animation: updown 1.5s linear infinite;
            }
            @keyframes updown {
              0% {
                transform: translateY(0);
              }
              50% {
                transform: translateY(-8px);
              }
              100% {
                transform: translateY(0);
              }
            }
            .location-canvas{
              position: absolute;
              left: 50%;
              bottom: -15px;
              transform: translateX(-48%) rotateX(45deg);
              z-index: 1;
            }
          }
        }
        .address-list {
          width: 645px;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: flex-start;
          padding-left: 15px;
          box-sizing: border-box;
          .address-item {
            width: 307px;
            margin-right: 15px;
            margin-bottom: 60px;
            padding: 20px;
            border-radius: 8px;
            box-sizing: border-box;
            &:nth-child(2n) {
              margin-right: 0;
            }
            .address-img {
              width: auto;
              height: 35px;
              display: block;
            }
            .address-title {
              font-family: Alibaba-PuHuiTi-R;
              font-size: 20px;
              color: #3f3f3f;
              margin-top: 10px;
            }
            .address-description {
              font-family: Alibaba-PuHuiTi-R;
              font-size: 14px;
              color: #3f3f3f;
              margin-top: 12px;
            }
            .address-phone {
              font-family: Alibaba-PuHuiTi-R;
              font-size: 18px;
              font-weight: 600;
              color: #00b0dc;
              margin-top: 8px;
              line-height: 1;
            }
            &.activity{
              box-shadow: 0px 4px 8px 0px rgb(139 139 139 / 18%);
              // background-image: linear-gradient(0deg, 
              //                   #ffffff 0%, 
              //                   #f2f7f5 100%);
              background-color: #d7edf2;
            }
          }
        }
      }
    }
  }
}
</style>